import { useEffect } from 'react'
import { useAppSelector } from '@crm-src/lib/store'

interface DynamicTitleProps {
  suffix?: string
  fallback?: string
}

export function DynamicTitle({ 
  suffix = 'CRM', 
  fallback = 'XOP CRM' 
}: DynamicTitleProps) {
  const tenant = useAppSelector((state) => state.auth.tenant)
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated)

  useEffect(() => {
    // Only update title if user is authenticated and has tenant data
    if (isAuthenticated && tenant?.name) {
      document.title = `${tenant.name} ${suffix}`
    } else if (isAuthenticated) {
      // User is logged in but no tenant name yet
      document.title = fallback
    } else {
      // User not logged in, use default
      document.title = fallback
    }
  }, [tenant?.name, isAuthenticated, suffix, fallback])

  return null // This component doesn't render anything
}
